import React, { Component } from 'react';
import { Field, reduxForm, change, formValueSelector, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Card from 'react-bootstrap/Card';
import FormControl from 'react-bootstrap/FormControl';
import FormGroup from 'react-bootstrap/FormGroup';
import Button from 'react-bootstrap/Button';
import withStyles from 'isomorphic-style-loader/withStyles';

import ImageUploadComponent from '../../Common/ImageUploadComponent/ImageUploadComponent.js';
import Loader from '../../Common/Loader/Loader';
import Link from '../../Link/Link.js';

import submit from './submit';
import messages from '../../../locale/messages';
import validate from './validate';
import { siteUrl, homePageCategoryBannerUploadDir, homePageCategoryLogoUploadDir } from '../../../config';
import { formatLocale } from '../../../helpers/formatLocale';

import addIcon from '../../../../public/Icons/plusIcon.svg';
import trashIcon from '../../../../public/Icons/deleteIocn.svg';

import s from './CategoryForm.css';
import bt from '../../../components/commonStyle.css';

export class CategoryForm extends Component {
	constructor(props) {
		super(props);
		this.handleDropzone = this.handleDropzone.bind(this);
		this.loaderStart = this.loaderStart.bind(this);
		this.loaderEnd = this.loaderEnd.bind(this);
		this.state = {
			selectedLanguages: []
		}
	}

	static defaultProps = { loading: false };

	UNSAFE_componentWillReceiveProps(nextProps) {
		const { dynamicTopFeatureTitle } = nextProps;
		let filteredLanguages = dynamicTopFeatureTitle?.map((item) => { return item?.language })
		this.setState({ selectedLanguages: filteredLanguages });
	}

	async loaderStart(index) {
		const { change } = this.props;
		await change(`categoryList.loading`, true);
	}

	async loaderEnd(index) {
		const { change } = this.props;
		await change(`categoryList.loading`, false);
	}

	renderField = ({ input, label, type, meta: { touched, error }, labelClass, fieldClass, placeholder, inputClassname }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={inputClassname}>
				{label && <label className={bt.labelText} >{label}</label>}
				<Form.Control {...input} placeholder={placeholder} type={type} className={bt.formControlInput} />
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
		const { formatMessage } = this.props.intl
		return (
			<div>
				<FormGroup className={cx(s.formGroup, 'noMargin')}>
					<div>
						<label className={bt.labelText} >{label}</label>
					</div>
					<div>
						<FormControl
							{...input}
							className={className}
							placeholder={label}
							as="textarea"
							rows="3"
						>
							{children}
						</FormControl>
						{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
					</div>
				</FormGroup>
			</div>
		);
	}

	renderFormControlSelect = ({ input, meta: { touched, error }, className, children, label }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={bt.space5}>
				{label && <label className={bt.labelText} >{label}</label>}
				<FormControl as="select" {...input} className={className} >
					{children}
				</FormControl>
				{touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
			</div>
		)
	}

	renderFieldArray = ({ fields, meta: { touched, error }, label }) => {
		const { languageList } = this.props;
		const { formatMessage } = this.props.intl;
		const { selectedLanguages } = this.state;

		!fields.length && fields.push({})
		return (
			<div className={bt.languageBox}>
				{fields.map((item, index) => {
					let fieldLength = fields.length - 1;
					const currentLanguage = fields?.get(index)?.language;
					const availableLanguages = languageList.filter(locale => !selectedLanguages?.includes(locale) || locale === currentLanguage);

					return (
						<div key={`${index}`}>
							<Row>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.mb30Xs}>
									<Field name={`${item}.language`} component={this.renderFormControlSelect} label={formatMessage(messages.language)} className={cx('noMargin', bt.formControlSelect, bt.formControlInput)}>
										<option value={''} >{formatMessage(messages.chooseLanguageLabel)}</option>
										{availableLanguages?.map((locale, index) => {
											return (
												<option value={locale} key={index}>{formatLocale(locale)}</option>
											)
										})}
									</Field>
									<Field name={`${item}.title`} type="text" component={this.renderField} label={label} placeholder={label} inputClassname={'noMargin'} />
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.noMargin}>
									<Field name={`${item}.description`} type="text" component={this.renderFormControlTextArea} label={formatMessage(messages.featureDesc1)} className={cx(bt.textAreaHeight)} />
								</Col>
							</Row>
							<div className={cx(bt.languageBtnContainer, 'darkLink', 'svgImg', { [bt.languageBtnContainerOne]: index != 0 })} >
								{(fields.length <= languageList?.length - 1) && fieldLength == index &&
									<Button onClick={() => fields.length <= languageList?.length - 1 && fields.push({})} className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")}>
										<img src={addIcon} alt='addIcon' />
										<span>	{formatMessage(messages.addLanguage)}</span>
									</Button>
								}
								{index != 0 && <div>
									<Button className={cx(bt.languageBtn, "textWhite", "btnBorderWhte")} onClick={() => fields.remove(index)}>
										<img src={trashIcon} alt='addIcon' />
										<span>{formatMessage(messages.deleteLanguage)}</span>
									</Button>
								</div>}
							</div>
						</div>
					)
				})}
			</div >
		)
	}

	handleDropzone(fileName, fieldName) {
		const { change } = this.props
		change(fieldName, fileName)
	}

	render() {
		const { handleSubmit, loading, submitting, logo, banner, id } = this.props;
		const { addFeatureLoader1, addFeatureLoader2 } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<div className={cx('cardSection', s.widthInner, bt.space5, s.responsiveNoPadding)}>
				<div className={s.responsiveNoPadding}>
					<h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{!id ? formatMessage(messages.addFeature) : formatMessage(messages.editFeature)}</h1>
					<Card className={s.card}>
						<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
							<Row>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={siteUrl + '/uploadHomePageCategoryLogo'}
													handleDropzone={this.handleDropzone}
													loaderName={'addFeatureLoader1'}
													loader={addFeatureLoader1}
													imageSrc={logo ? siteUrl + homePageCategoryLogoUploadDir + logo : null}
													fieldName={'logo'}
													formName={'CategoryForm'}
													label={formatMessage(messages.aboutImage1)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
								<Col lg={6} md={6} sm={12} xs={12} className={bt.space2}>
									<Form.Group className={s.formGroup}>
										<div className={cx(s.profileImgSection, 'bgBlackTwo')}>
											<div className={'commonFilepicker'}>
												<ImageUploadComponent
													className={cx(bt.btnPrimary, 'fileNoPadding', s.btnWidthadmin)}
													subTextClass={cx(s.subText, 'textWhiteTwo')}
													subText={formatMessage(messages.maximumUploadSizeLabel)}
													defaultMessage={formatMessage(messages.chooseFile)}
													postUrl={siteUrl + '/uploadHomePageCategoryBanner'}
													handleDropzone={this.handleDropzone}
													loaderName={'addFeatureLoader2'}
													loader={addFeatureLoader2}
													imageSrc={banner ? siteUrl + homePageCategoryBannerUploadDir + banner : null}
													fieldName={'banner'}
													formName={'CategoryForm'}
													label={formatMessage(messages.aboutImage2)}
													labelClass={cx(s.textAlignLeft, 'textAlignLeft', s.dropzoneLabelTitle)}
												/>
											</div>
										</div>
									</Form.Group>
								</Col>
							</Row>
							<Row>
								<Col lg={12} md={12} sm={12} xs={12}>
									<Form.Group className={cx(s.formGroup, 'noMargin')}>
										<div>
											<FieldArray name='title' rerenderOnEveryChange={true} component={this.renderFieldArray} label={formatMessage(messages.featureTitle1)} />
										</div>
									</Form.Group>
								</Col>
							</Row>
							<div className={cx(bt.textAlignRight, bt.spaceTop5, bt.paddingTop5, bt.languageBtnDivider, 'textAlignLeftRTL', 'loadingBtnRTL')}>
								<Form.Group className={s.formGroup}>
									<div className='btnFlexContainer'>
										<Link to={'/siteadmin/homepage/top-feature'} className={cx(bt.btnSecondary, 'backBtnRTL')} >{formatMessage(messages.goBack)}</Link>
										<div className={s.displayInlineBlock}>
											<Loader
												type={"button"}
												label={!id ? formatMessage(messages.submitButton) : formatMessage(messages.update)}
												show={loading}
												buttonType={'submit'}
												className={cx(bt.btnPrimary)}
												disabled={submitting || loading}
												isSuffix={true}
											/>
										</div>
									</div>
								</Form.Group>
							</div>
						</Form>
					</Card>
				</div>
			</div >
		)
	}
}

CategoryForm = reduxForm({
	form: 'CategoryForm',
	onSubmit: submit,
	validate
})(CategoryForm);

const selector = formValueSelector('CategoryForm');
const mapState = (state) => ({
	logo: selector(state, 'logo'),
	banner: selector(state, 'banner'),
	categoryList: selector(state, 'categoryList'),
	loading: state?.loader?.CategoryForm,
	imageLoader: state?.loader,
	dynamicTopFeatureTitle: selector(state, 'title'),
	languageList: state?.runtime?.availableLocales,
	id: selector(state, 'id'),
	addFeatureLoader1: state?.loader?.addFeatureLoader1,
	addFeatureLoader2: state?.loader?.addFeatureLoader2
});
const mapDispatch = { change };

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(CategoryForm)));